import React from 'react'
import { motion } from 'framer-motion'
import { cn } from '../../lib/utils'

const variants = {
  // The Sticker (Primary Action)
  sticker: 'bg-gradient-psych text-white border-white shadow-sticker hover:shadow-sticker-hover',
  
  // The Stomp Box (Secondary/Toggle)
  stompbox: 'stomp-box text-white',
  
  // Ghost/Outline
  ghost: 'bg-transparent text-neon-cyan border-neon-cyan hover:bg-neon-cyan/10',
  
  // Danger State
  danger: 'bg-grunge-red text-white border-white shadow-sticker hover:shadow-sticker-hover',
}

export default function Button({ 
  children, 
  variant = 'sticker', 
  active = false,
  className,
  onClick,
  disabled = false,
  type = 'button',
  ...props 
}) {
  const isStompbox = variant === 'stompbox'
  
  const baseClasses = cn(
    // Base Tour Rider styling
    'px-6 py-4 font-setlist font-bold uppercase tracking-wider',
    'border-3 transition-all duration-200',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neon-cyan focus-visible:ring-offset-2 focus-visible:ring-offset-ink',
    'disabled:opacity-50 disabled:cursor-not-allowed',
    
    // Variant-specific styling
    !isStompbox && 'rounded-sticker sticker',
    isStompbox && active && 'active',
    
    variants[variant],
    className
  )

  const motionProps = isStompbox ? {
    whileTap: { scale: disabled ? 1 : 0.98, y: disabled ? 0 : 2 }
  } : {
    whileHover: { scale: disabled ? 1 : 1.05, y: disabled ? 0 : -2, rotate: disabled ? -1 : 2 },
    whileTap: { scale: disabled ? 1 : 0.95, rotate: -0.5 }
  }

  return (
    <motion.button
      {...motionProps}
      className={baseClasses}
      onClick={onClick}
      disabled={disabled}
      type={type}
      {...props}
    >
      {children}
    </motion.button>
  )
}
